/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { Modal, Popover, Divider, Input, InputProps, Button } from 'antd'
import { logout, wechatUnbindMobile } from '../../actions/main'
import { setPersonalVip } from '../../slices/mySpace/personalSpaceSlice'
import { post } from '../my-space/utils/request'
import personalVipIcon from '../../images/icon_vip_personal.png'
import Group from './Group'
import CONFIG from '../../constants/config'

import contact_us_icon from '../../images/contact_us.png'
import desktopLib from '../../utils/desktopLib'
import sensors from '../../utils/sensors'
import ContactUS from '../components/ContactUS'
import { PoweroffOutlined, SearchOutlined } from '@ant-design/icons'

const PopoverContent = () => (
  <div style={{ width: '324px' }}>
    <p>
      如果遇到状况无法进入团队，可能是当前的浏览器版本过低或浏览器兼容问题，建议使用最新版本的搜狗浏览器的【极速模式】进行操作。
    </p>
    <p>
      <a
        style={{ textDecoration: 'underline' }}
        href="https://ie.sogou.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        下载搜狗浏览器
      </a>
    </p>
    <h4 style={{ color: 'rgba(0, 0, 0, 0.65)', marginTop: '20px' }}>
      <ContactUS fromPage="选择团队进入">
        <span className="contact-item">
          <img style={{ width: '105px' }} src={contact_us_icon} />
        </span>
      </ContactUS>
    </h4>
    <Divider style={{ margin: '0 0 12px 0' }} />
    <div
      style={{
        display: 'inline-block',
        marginRight: '100px',
        verticalAlign: 'top'
      }}
    >
      <h4>客服电话</h4>
      <div
        style={{
          width: '140px',
          height: '35px',
          backgroundColor: '#E6E9ED',
          color: '#0093FF',
          fontSize: '18px',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {CONFIG.CUSTOMER_PHONE}
      </div>
    </div>
  </div>
)

const Help = () => (
  <Popover content={<PopoverContent />}>
    <span style={{ color: '#0094FF' }}>无法进入？</span>
  </Popover>
)

const SearchInput = (props: InputProps) => (
  <div style={{ position: 'relative', height: '100%' }}>
    <Input
      style={{
        width: '220px',
        position: 'absolute',
        right: 30,
        top: '50%',
        transform: 'translate3d(0, -50%, 0)'
      }}
      prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
      placeholder="搜索团队名称"
      allowClear
      {...props}
    />
  </div>
)

function ChooseGroup() {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const user = useAppSelector((state) => state.main.user)
  const isSpaceOpen = useAppSelector(
    (state: any) => state.mySpace?.personalSpace?.isSpaceOpen ?? false
  )
  const isPersonalVip = useAppSelector(
    (state: any) => state.mySpace?.personalSpace?.isPersonalVip ?? false
  )
  const isBinding = useMemo(() => {
    const params = new URLSearchParams(location.search)
    return params.get('from') === 'binding'
  }, [location.search])

  const [groupName, setGroupName] = useState('')
  const [autoSwitchGroupId, setAutoSwitchGroupId] = useState<string | null>(
    null
  )

  useEffect(() => {
    // 个人空间开通状态由 App.js 登录流程统一拉取并写入 store，不再重复请求

    // 拉取个人会员状态，用于个人空间入口的会员标识
    const userID = user?.user_id
    if (userID) {
      post('/web/user/vip/info', { userID })
        .then((res: any) =>
          dispatch(
            setPersonalVip({
              isVip: res?.personalVip?.isVip ?? false,
              loaded: true
            })
          )
        )
        .catch(() => dispatch(setPersonalVip({ isVip: false, loaded: true })))
    }

    // 个人空间上线阶段：暂时禁用自动跳转，始终停留在选择页让用户手动选择
    // 恢复时取消注释以下代码
    /*
    const lastLogoutGroupObj = JSON.parse(
      localStorage.getItem('last_logout_group_id') || 'null'
    )
    if (lastLogoutGroupObj) {
      Object.keys(lastLogoutGroupObj).forEach((user_id) => {
        if (user_id === user?.user_id) {
          user?.groups?.forEach((group) => {
            if (group.group_id === lastLogoutGroupObj[user_id]) {
              setAutoSwitchGroupId(group.group_id)
              localStorage.removeItem('last_logout_group_id')
              return
            }
          })
        } else {
          return
        }
      })
    }
    */
  }, [user])

  const handleLogout = () => dispatch(logout())

  const renderTitle = () => {
    if (isBinding) {
      return (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src={user?.headimgurl}
              style={{
                width: 32,
                height: 32,
                marginRight: 9
              }}
            />
            <span style={{ fontSize: 16 }}>{user?.nickname}</span>
          </div>
          <div
            style={{
              marginTop: 12,
              fontSize: 16,
              color: '#666',
              fontWeight: 'normal'
            }}
          >
            拥有以下团队
          </div>
        </>
      )
    } else {
      // 非绑定场景：标题行左侧显示标题+帮助链接，右侧显示搜索框
      // antd6 的 closeIcon 槽为固定 32×32 按钮容器，搜索框放入后产生空占位，故移到 title 里
      // 直接内联渲染 Input 避免 SearchInput 组件内 position:absolute 在 flex 容器中错位
      const titleSearchInput = (
        <Input
          style={{ width: '220px', marginLeft: 'auto' }}
          prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder="搜索团队名称"
          allowClear
          value={groupName}
          onChange={(e) => setGroupName(e.target.value.trim())}
        />
      )
      return desktopLib.isDesktop ? (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <span>选择团队进入</span>
          {titleSearchInput}
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <span>
            选择团队进入
            <Divider orientation="vertical" />
            <Help />
          </span>
          {titleSearchInput}
        </div>
      )
    }
  }

  const renderFooter = () => {
    if (isBinding) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 40
          }}
        >
          不是需要绑定的账号，
          <a
            onClick={() => {
              sensors.track('web_click_page_workgroup_list_choose', {
                clickItem: 'changenum',
                groupNum: `${user?.groups?.length || 0}`,
                bool1: isSpaceOpen
              })

              dispatch(wechatUnbindMobile()).then(() => dispatch(logout()))
            }}
          >
            更换手机号绑定
          </a>
        </div>
      )
    }

    return null
  }

  return (
    <div className="Login">
      {!isBinding && (
        <div className="welcome">
          你好，{user?.nickname}
          <Divider
            orientation="vertical"
            style={{ backgroundColor: '#D1D5E1', margin: '0 12px' }}
          />
          <span className="logout" onClick={handleLogout}>
            <PoweroffOutlined
              style={{ marginRight: '4px', fontSize: '15px' }}
            />
            退出
          </span>
        </div>
      )}
      <Modal
        title={renderTitle()}
        width={680}
        getContainer={false}
        open
        centered={true}
        closable={false}
        mask={false}
        destroyOnHidden
        footer={null}
      >
        <div className="groups-container">
          {/* 个人空间固定选项（isOpen=true 时才显示） */}
          {isSpaceOpen && (
            <div className="group">
              <div className="group-wrapper">
                {user?.headimgurl ? (
                  <img
                    className="group-icon"
                    src={user.headimgurl}
                    style={{ objectFit: 'cover', borderRadius: 4 }}
                    alt=""
                  />
                ) : (
                  <div
                    className="group-icon"
                    style={{
                      backgroundColor: '#0070F4',
                      color: '#fff',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 4
                    }}
                  >
                    {user?.nickname ? user.nickname.slice(0, 2) : '我'}
                  </div>
                )}
                <p className="group-name">
                  {user?.nickname}的个人空间
                  {isPersonalVip && (
                    <img
                      src={personalVipIcon}
                      alt=""
                      style={{
                        height: 20,
                        width: 'auto',
                        marginLeft: 6,
                        verticalAlign: 'middle'
                      }}
                    />
                  )}
                  <span
                    style={{
                      marginLeft: 8,
                      fontSize: 12,
                      color: '#8c8c8c',
                      fontWeight: 'normal'
                    }}
                  >
                    仅自己可见
                  </span>
                </p>
              </div>
              <Button
                type="primary"
                onClick={() => {
                  sensors.track('web_click_page_workgroup_list_choose', {
                    clickItem: 'enterPersonalSpace',
                    groupNum: `${user?.groups?.length ?? 0}`,
                    groupID: '',
                    bool1: true
                  })
                  window.location.href = '/my-space/personal-space'
                }}
              >
                进入
              </Button>
            </div>
          )}

          {user?.groups?.length ? (
            user.groups
              .filter((group) => group.group_name?.includes(groupName))
              .map((group, index) => (
                <Group
                  key={index}
                  group={group}
                  autoSwitchGroupId={autoSwitchGroupId}
                  onTrack={() => {
                    sensors.track('web_click_page_workgroup_list_choose', {
                      clickItem: 'enter',
                      groupNum: `${user.groups?.length ?? 0}`,
                      groupID: group.group_id,
                      bool1: isSpaceOpen
                    })
                  }}
                />
              ))
          ) : (
            <>
              <p className="no-group">您尚未加入任何团队</p>
              <div className="no-group-detail">
                <div>请联系管理员加入团队 或</div>
                <div>在登录页使用【手机号+验证码】方式创建新团队</div>
              </div>
            </>
          )}
        </div>

        {renderFooter()}
      </Modal>
    </div>
  )
}

export default ChooseGroup
